import { Components, CssVarsTheme, Theme } from "@mui/material";

declare module "@mui/material/Button" {
  interface ButtonClasses {
    textPrimaryLight: true;
    colorPrimaryLight: true;
    outlinedPrimaryLight: true;
    containedPrimaryLight: true;
  }

  interface ButtonPropsColorOverrides {
    primaryLight: true;
    // inherit: false;
    // secondary: false;
    // warning: false;
    // info: false;
    // success: false;
  }
}

const Button = (): Components<
  Omit<Theme, "components" | "palette"> & CssVarsTheme
> => ({
  MuiButton: {
    styleOverrides: {
      text: {
        borderRadius: "8px",
        fontWeight: 600,
        textTransform: "none",
      },
      contained: {
        borderRadius: "8px",
        fontWeight: 600,
        textTransform: "none",
      },
      outlined: {
        borderRadius: "8px",
        fontWeight: 600,
        textTransform: "none",
      },
      // containedPrimary: {
      //   backgroundColor: theme.palette.primary.main,
      // },
      // containedPrimaryLight: {
      //   boxShadow: "none",
      //   color: theme.palette.primary.main,
      //   background: theme.palette.primary.light,
      //   ":hover": {
      //     background: theme.palette.primary.main,
      //     color: theme.palette.primary.light,
      //     boxShadow: "none",
      //   },
      // },
      // outlinedPrimary: {
      //   backgroundColor: theme.palette.grey[100],
      //   color: theme.palette.grey[800],
      //   ":hover": {
      //     backgroundColor: theme.palette.grey[200],
      //   },
      // },
      // sizeLarge: {
      //   // padding: "calc(.775rem + 1px) calc(1.5rem + 1px)",
      // },
      // sizeMedium: {
      //   // fontSize: "16px",
      //   // padding: "10px 18px",
      // },
      // sizeSmall: {
      //   // padding: "10px 18px",
      //   // padding: "calc(.500rem + 1px) calc(1.5rem + 1px)",
      // },
    },
  },
});

export default Button;
